<template>
	<div class="modal fade" id="modal-filter" role="dialog" data-backdrop="static">
		<div class="modal-dialog modal-lg bani-modal h-100">
			<div class="modal-content w-limit vh-100" style="border-radius: 0">
				<div class="modal-header">
					<div class="nav-btn kiri tutup">
						<img src="../../../../assets/img/x2.svg" @click="back" alt="">
					</div>
					<h5 class="navbar-title text-center">Filter</h5>
					<div class="nav-btn kanan">
					</div>
				</div>

				<div class="content-wrapper">
					<div class="vh-100">
						<div class="p-x-20 p-y-8 bg-grey">
							<img src="@/assets/icons/alert-info.svg" alt="">
							<span class="f-regular f-12 f-c-midgrey">
								Kosongi semua filter untuk memilih seluruh konsumen
							</span>
						</div>
						<SOFilterPeriode
							:id="'filter-periode'"
							:title="'Rentang tanggal'"
							:option-data="optionData.periode.data"
							v-model="optionData.periode.selected"
							:filter-global-key="optionData.periode.filterGlobalKey"
						/>
						<SOFilterOutlet
							:id="'filter-outlet'"
							:use-check-all="true"
						/>
						<SOFilterLayananOwner
							:id="'filter-layanan-owner'"
							:with-option="optionData.layananOwner.data.length > 0"
							:option-data="optionData.layananOwner.data"
							:option-selected="optionData.layananOwner.selected"
						/>
						<SOFilterPaketDeposit
							:id="'filter-paket-deposit'"
							:title="'Memiliki deposit'"
						/>

                        <div class="border-top">
                            <SOFilterTitle :title="'Pencarian'" :diterapkan="search !== ''" :id="'search'"/>
                            <div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="'search'">
                                <SOInputSearch
                                    :value="search"
                                    :id="'filter-search'"
                                    :autocomplete="'off'"
                                    :delay-time="100"
                                    :do-searching="setSearchKey"
                                />
                            </div>
                        </div>
					</div>

					<div class="nav-bottom-wrapper">
						<div class="p-x-20 d-flex-between-center w-limit">
							<div class="f-semi f-16 f-c-blue" @click="resetFilter">
								Reset
							</div>
							<div>
								<button class="btn btn-primary" @click="doFilter">
									Terapkan kriteria
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {moduleName} from "./../../store/state"
import {mapActions, mapGetters} from "vuex";
import SOFilterPeriode from "@/so-components/global/filter/type/SOFilterPeriode";
import SOFilterOutlet from "@/so-components/global/filter/type/SOFilterOutlet";
import SOFilterLayananOwner from "@/so-components/global/filter/type/SOFilterLayananOwner";
import SOFilterPaketDeposit from "@/so-components/global/filter/type/SOFilterPaketDeposit";
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputSearch from "@/so-components/global/input/SOInputSearch";

export default {
	name: "ModalFilterWABlastKonsumen",
	components: {
		SOFilterPeriode,
		SOFilterOutlet,
		SOFilterLayananOwner,
		SOFilterPaketDeposit,
        SOFilterTitle,
        SOInputSearch,
	},
	mounted() {
		$("#modal-filter").modal("show");
		this.filterItemCopy = JSON.parse(JSON.stringify(this.filterItem))
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem",
			filterSetting: "getFilterSetting",
		}),
        ...mapGetters(moduleName, {
            payload: "payloadCreateBlast",
            search: "search",
        })
	},
	data() {
		return {
			optionData: {
				periode: {
					data: [
						{
							id: "periode_terdaftar",
							text: "Tanggal terdaftar",
						},
						{
							id: "periode_transaksi",
							text: "Tanggal berkunjung",
						},
						{
							id: "periode_tidak_transaksi",
							text: "Tidak pernah berkunjung",
						},
					],
					selected: "periode_terdaftar",
					filterGlobalKey: "filterRentangTanggalKonsumen"
				},
				layananOwner: {
					data: [
						{
							id: "transaksi_semua_layanan",
							text: "Pernah transaksi dg semua layanan",
						},
						{
							id: "transaksi_salah_satu_layanan",
							text: "Pernah transaksi dg semua/salah satu layanan",
						},
						{
							id: "transaksi_tanpa_layanan",
							text: "Tidak pernah transaksi dg layanan",
						},
					],
					selected: "",
					filterGlobalKey: "",
				},
			},
			filterItemCopy: {},
		}
	},
    watch: {
        "filterItem.filterLayananOwner": {
            handler: function () {
                console.log(this.filterItem.filterLayananOwner)
                this.optionData.layananOwner.selected = this.filterItem.filterLayananOwner
                console.log("this.layananOwner.selected", this.layananOwner.selected)
            },
            deep: true,
        },
    },
	methods: {
        ...mapActions({
            setSearch: `${moduleName}/setSearch`,
            setPayloadCreateBlast: `${moduleName}/setPayloadCreateBlast`,
            fetchListCustomer: `${moduleName}/fetchListCustomer`,
        }),
		back(payload) {
			this.$store.commit("filterGlobalModule/setFilterItem", this.filterItemCopy)
			$("#modal-filter").modal("hide");
			setTimeout(() => {
				this.$router.back()
			}, 500)
		},
		resetFilter() {
			this.$store.commit(moduleName + "/setSearch", "")
			this.$store.commit("filterGlobalModule/resetFilterItem")
			this.$store.commit("filterGlobalModule/resetFilter")
		},
        setSearchKey(input) {
            this.setSearch(input)
        },
		doFilter() {
			$("#modal-filter").modal("hide");
			setTimeout(() => {
				this.$router.back()
			}, 500)
			// trigger reset and fetch data

            this.payload.filter_customer = {
                key: this.search,
                filter_by: this.filterItem.periode.filterBy,
                tahun: this.filterItem.periode.year,
                bulan: this.filterItem.periode.month,
                tanggal_awal: this.filterItem.periode.startDate,
                tanggal_akhir: this.filterItem.periode.endDate,
                filter_kolom: this.filterItem.filterRentangTanggalKonsumen,
                filter_layanan_by: this.filterItem.filterLayananOwner,
                idlayanan_array: this.filterItem.layananOwner,
                iddeposit_array: this.filterItem.deposit,
                outlet_array: this.filterItem.outlet,
            }
            this.setPayloadCreateBlast(this.payload)
            this.fetchListCustomer(this.payload.filter_customer)
		}
	}
}
</script>